import type { Translations } from './en.js';

const ja: Translations = {
  ok: 'OK',
  cancel: 'キャンセル',
  close: '閉じる',
  confirm: '確認',
  language: '言語',

  game_title: '剣強化',
  tap_to_start: 'タップしてスタート',
  title_load_failed: 'タイトル画像の読み込み失敗:',
  game_started: '剣強化ゲーム開始！',

  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: '🎉 オールクリア！',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% ⬆',
  gold_display: '{amount} G',
  gold_display_free: '0 G (無料！)',

  btn_enhance: '⚒️ 強化',
  btn_enhance_ready: '⚔️ 強化',
  btn_enhance_complete: '🏆 完了',
  btn_free_enhance: '▶ 無料強化',
  btn_exhausted: '残なし',
  btn_boost: '確率\nUP',
  btn_applying: '適用\n中！',
  btn_protection_active: '🛡️ 保護中',
  btn_protection_use: '🛡️ スクロール使用',
  btn_sell: '💰 売却',
  btn_sell_amount: '💰 {amount}G',
  btn_shop: '🏪 ショップ',
  cost_max: 'MAX',
  cost_free: '0 G (無料！)',

  tab_settings: '⚙️ 設定',
  tab_inventory: '📦 インベントリ',
  bgm_on: '🎵 BGM ON',
  bgm_off: '🎵 BGM OFF',
  sfx_on: '🔊 効果音 ON',
  sfx_off: '🔊 効果音 OFF',
  inventory_title: '⚔️ 保管した武器',
  inventory_empty: '保管された武器はありません',
  equip: '装備',
  equip_msg: '{name} 装備！',
  reset_confirm_title: '⚠️ 本当にリセットしますか？',
  reset_confirm_desc: 'すべての進行状況が削除されます',
  reset: 'リセット',
  reset_start_over: '🔄 最初からやり直す',
  menu_close: '閉じる',

  inv_scrolls_title: '🛡️ 保護券の所持',
  inv_scrolls_line1: '初級: {c0}  |  中級: {c1}',
  inv_scrolls_line2: '上級: {c2}  |  超上級: {c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  ad_gold_title: '広告を見て無料強化',
  ad_gold_desc: '強化費用1回 0ゴールド',
  ad_gold_note: '(保護券・確率UPも有効)',
  ad_gold_confirm: '▶ 広告視聴',
  ad_gold_free_next: '次の強化は無料！',
  ad_gold_exhausted: '使用回数終了！',
  ad_gold_remaining: '残り回数: {current}/3',

  boost_popup_title: '📺 広告視聴',
  boost_confirm: '▶ 広告を見て適用',
  boost_close: '閉じる',
  boost_applied: '確率UP適用！',
  boost_already_applied: 'すでに適用中！',
  boost_exhausted: '使用回数終了！',
  boost_remaining: '🎬 残り使用回数: {current}/3',
  boost_popup_desc: '現在 {rate}% → {mult} 適用',
  boost_rate_display: '{rate}%',
  boost_mult_2x: '2倍',
  boost_mult_1_5x: '1.5倍',
  boost_mult_1_3x: '1.3倍',

  protection_popup_title: '🛡️ 保護券使用',
  protection_use: '使用する',
  protection_cancel: 'キャンセル',
  protection_popup_info:
    '現在のレベル: Lv.{level}\n必要: {name} 1個\n所持: {count}個',
  protection_activated: '{name} 発動！',
  protection_returned: '{name} 返却',
  protection_protected: '🛡️ 保護券で守られた！',

  msg_max_level: 'すでに最高レベルです！',
  msg_gold_short: 'ゴールド不足！',
  msg_success_boost: 'ブースト強化成功！',
  msg_success: '強化成功！',
  msg_destroyed: '💥 破壊！',

  shop_title: 'ショップ',
  tab_protection: '保護スクロール',
  tab_weapons: '武器購入',
  weapon_shop_title: '⚔️ 武器購入',
  item_free: '無料',
  close_shop: '閉じる',
  buy_complete_title: '購入完了！',
  buy_complete_desc: '購入したアイテムは\n上部 ⚙️ 設定 → 📦 インベントリで\n確認できます！',
  buy_complete_ok: '確認',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: '{name} 入手！',
  weapon_moved_to_inventory: '{name} → インベントリ',
  price_display: '{amount}G',
  sell_received: '{amount}G 獲得！',

  destroy_title: '武器が破壊されました',
  destroy_ad_restore: '▶ 広告を見て復元',
  destroy_restore_ad: '広告を見て復元 ({current}/{max})',
  destroy_give_up: '最初からやり直す',
  destroy_restore_count: '🎬 残り復元機会: {current}/{max}',
  destroy_restored: 'Lv.{level} weapon restored!',
  ad_watch_fail: '広告の視聴に失敗',
  weapon_restored: '{name} 復元完了！',

  completion_title: '最強の剣を完成させました！',
  completion_all_done: '🏆 すべての強化完了！ 🏆',
  congrats_text: '🎉 おめでとうございます！ 🎉',
  register_name: '✏️ 名前を登録',
  prompt_register_name: '殿堂に登録する名前を入力してください:',
  no_completion: 'まだ達成者がいません',
  be_first: '最初の達成者になりましょう！',
  completion_close: '閉じる',
  leaderboard_title: '📋 殿堂',
  leaderboard_entry: '{rank}位 - {name}',
  completion_rank_msg: 'あなたは {rank}番目の達成者です！',
  completion_total_msg: 'これまでに {total}人が達成しました',

  weapon_image_load_failed: '武器画像の読み込み失敗:',

  weapon_0: '素手',
  weapon_1: '普通の短剣',
  weapon_2: '鉄剣',
  weapon_3: '銀剣',
  weapon_4: 'スノーボード剣',
  weapon_5: 'ウェーブ剣',
  weapon_6: '魔法少女の剣',
  weapon_7: '熊の剣',
  weapon_8: '燃える骸骨剣',
  weapon_9: '雷剣',
  weapon_10: '月光の短剣',
  weapon_11: 'ドラゴンソード',
  weapon_12: '筋肉剣',
  weapon_13: '王ダイヤ剣',
  weapon_14: '青龍偃月刀',
  weapon_15: '古代の剣',
  weapon_16: '海賊王の双剣',
  weapon_17: 'ドバイもっちり剣',
  weapon_18: '七七刀',
  weapon_19: '魔法少女の杖剣',
  weapon_20: 'ブンブン剣',
  weapon_21: 'パレット剣',
  weapon_22: '大自然の剣',
  weapon_23: 'サイボーグ剣',
  weapon_24: 'ブラックホール剣',
  weapon_25: 'ゴールデンバード剣',
  weapon_26: 'クリスタルパワー剣',
  weapon_27: 'ダークドラゴン剣',
  weapon_28: 'ハサミ剣',
  weapon_29: 'AI剣',
  weapon_30: 'チェーンソー剣',
  weapon_31: '流星の力の剣',
  weapon_32: 'ダークダーク剣',
  weapon_33: 'ギャラクシー剣',
  weapon_34: '超高級ダイヤ剣',

  scroll_basic: '初級保護券',
  scroll_mid: '中級保護券',
  scroll_hi: '上級保護券',
  scroll_ultra: '超上級保護券',
  scroll_label_basic: '初級',
  scroll_label_mid: '中級',
  scroll_label_hi: '上級',
  scroll_label_ultra: '超上級',

  // === Materials (Sprint 1) ===
  mat_iron_dust: '粗鉄の粉',
  mat_refining_core: '精錬コア',
  mat_lava_essence: '溶岩精',
  mat_abyss_crystal: '深淵結晶',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: '素材獲得！',
  mat_double_ad: '広告で2倍',
  mat_doubled: '2倍適用！',
  mat_panel_title: '素材',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: '保管',
  keep_full: '保管庫満杯！',
  keep_lv1_blocked: 'Lv.1の武器は保管できません',
  keep_success: '{name} 保管！',
  keep_retrieve: '装備',
  keep_sell: '売却',
  keep_slot_expand: 'スロット拡張',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: 'スロット: {used}/{total}',
  keep_panel_title: '保管武器',
  keep_empty: '保管武器なし',
  keep_weapon_entry: 'Lv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: 'スロットを増やしてください！',

  // === 鍛冶場 (Sprint 2) ===
  tab_forge: '鍛冶場',
  forge_title: '鍛冶場',
  forge_tab_weapon: '武器',
  forge_tab_scroll: '巻物',
  forge_tab_upgrade: '素材昇格',
  forge_craft_btn: '製作',
  forge_craft_success: '{name} 製作完了！',
  forge_not_enough_mat: '素材不足',
  forge_weapon_to_equip: '今すぐ装備しますか？',
  forge_weapon_to_keep: '保管',
  forge_weapon_equip: '装備',
  forge_keep_full_equip: '保管庫満杯 — 直接装備します。',
  forge_cost_label: 'コスト:',
  forge_result_label: '結果:',

  forge_recipe_weapon_lv5: 'Lv.5 武器製作',
  forge_recipe_weapon_lv10: 'Lv.10 武器製作',
  forge_recipe_weapon_lv15: 'Lv.15 武器製作',
  forge_recipe_weapon_lv21: 'Lv.21 武器製作 (ピティ)',
  forge_recipe_weapon_lv21_desc: '強化なしでLv.21武器を即入手！(失敗なし)',
  forge_recipe_scroll_basic: '初級保護巻物製作',
  forge_recipe_scroll_mid: '中級保護巻物製作',
  forge_recipe_scroll_hi: '上級保護巻物製作',
  forge_recipe_scroll_ultra: '超上級保護巻物製作',
  forge_recipe_upgrade_1: '粗鉄の粉 → 精錬コア',
  forge_recipe_upgrade_2: '精錬コア → 溶岩精',
  forge_recipe_upgrade_3: '溶岩精 → 深淵結晶',

  scroll_effect_basic: 'Lv.1-9 強化失敗時の破壊を防ぐ',
  scroll_effect_mid: 'Lv.10-19 強化失敗時の破壊を防ぐ',
  scroll_effect_hi: 'Lv.20-24 強化失敗時の破壊を防ぐ',
  scroll_effect_ultra: 'Lv.25-34 強化失敗時の破壊を防ぐ',
  scroll_buy_btn: '購入',

  keep_card_equip: '装備',
  keep_card_sell: '売却',
  keep_slot_empty: '空きスロット',

  sacrifice_btn: '武器を捧げる',
  sacrifice_panel_title: '武器を生贄に捧げる',
  sacrifice_panel_desc: 'Lv.{level}武器を生贄にすると成功率が1個あたり+{tierPct}%アップ',
  sacrifice_empty: '保管庫にLv.{level}武器なし',
  sacrifice_bonus_label: 'ボーナス: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: '捧げる',
  sacrifice_ad_slots: '広告視聴で成功率 +{pct}%',
  sacrifice_ad_exhausted: '広告上限に達しました',
  sacrifice_ad_granted: '生贄+3追加！',
  sacrifice_added: '生贄受理！+{tierPct}%ボーナス',
  sacrifice_cap_reached: '生贄上限に達しました',
  sacrifice_reset: '生贄ボーナスリセット',

  infinity_btn: 'インフィニティ',
  infinity_active: '無料 {sec}秒',
  infinity_popup_title: 'インフィニティモード',
  infinity_popup_desc: '10秒間ゴールド不要で強化し放題！\n成功率はいつも通り — 失敗で破壊もあり！',
  infinity_popup_confirm: '広告を見る',
  infinity_popup_close: '閉じる',
  infinity_cooldown: '{sec}秒後使用可',
  infinity_daily_exhausted: '本日の上限に達しました',
  infinity_started: 'インフィニティモードON！10秒間無料',
  infinity_ended: 'インフィニティモード終了',

  buff_item_luck_charm: '幸運のお守り',
  buff_item_guarantee: '強化保証券',
  buff_item_destroy_guard: '破壊防止券',
  buff_item_use: '使用',
  buff_item_active: '有効',
  buff_item_empty: '0',
  buff_luck_charm_activated: '幸運のお守り有効！次の強化+5%',
  buff_guarantee_activated: '強化保証券有効！次の強化100%成功',
  buff_destroy_guard_activated: '破壊防止券有効！次の失敗で破壊なし',
  buff_luck_charm_consumed: '幸運のお守り消費',
  buff_guarantee_consumed: '強化保証券消費',
  buff_destroy_guard_consumed: '破壊防止券消費 — 破壊を防ぎました！',
  buff_item_already_active: 'すでに有効です！',
  buff_item_none: '{name}がありません',
  buff_popup_count: '所持: {count}個',
  buff_popup_use_btn: '使用する',
  buff_popup_no_stock: '所持なし。鍛冶場で製作できます。',
  buff_popup_luck_charm_effect: '次の強化成功率+5%アップ',
  buff_popup_guarantee_effect: '次の強化1回を100%成功に保証',
  buff_popup_destroy_guard_effect: '次の強化失敗時に武器の破壊を防ぐ（1回）',

  forge_recipe_item_luck_charm: '幸運のお守りを作成',
  forge_recipe_item_luck_charm_desc: '次の強化成功率+5%',
  forge_recipe_item_guarantee: '強化保証券を作成',
  forge_recipe_item_guarantee_desc: '次の強化100%成功',
  forge_recipe_item_destroy_guard: '破壊防止券を作成',
  forge_recipe_item_destroy_guard_desc: '次の失敗時破壊防止',
  forge_tab_item: 'アイテム',
};

export default ja;
